import { noop } from 'lodash';
import React from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { SUGGESTED_VARIATION_LISTINGS } from '../../../propTypes';
import SuggestedVariationCard from '../../cards/SuggestedVariationCard';
import VariationListings from '../VariationListings';

const SuggestedVariationListings = ({ variations, selectedSuggestionsIds = [], onSuggestionChange = noop }) => {

    const loadMore = () => new Promise((resolve) => {
        // TODO This should refer pagination API once implemented
        setTimeout(resolve, 1000);
    });

    const onSelect = (variationId) => {
        const isSelected = selectedSuggestionsIds.includes(variationId);

        const newSuggestions = isSelected ? selectedSuggestionsIds.filter((id) => id !== variationId)
            : [...selectedSuggestionsIds, variationId];

        onSuggestionChange(newSuggestions);
    };

    return (
        <VariationListings variations={variations}
            loadMore={loadMore}
            wrapperClass="grid-12"
            brandName={translate('variations_display.brand_name_placeholder')}
            slogan={translate('variations_display.slogan_placeholder')}
            renderChild={(variation) => (
                <div key={variation.id} className="col-6-xs col-4-sm col-3-md">
                    <SuggestedVariationCard {...variation}
                        selected={selectedSuggestionsIds.includes(variation.id)}
                        onSelect={onSelect}/>
                </div>
            )}/>
    );
};

SuggestedVariationListings.propTypes = SUGGESTED_VARIATION_LISTINGS;

export default SuggestedVariationListings;
